import React from "react";

interface IFileUploadIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const FileUploadIcon: React.FC<IFileUploadIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
            <path d="M12 12v6"></path>
            <path d="m15 15-3-3-3 3"></path>
        </svg>
    );
}
